import { useResolvedTheme } from '@/hooks/app/useResolvedTheme'
import { useAppPreferencesStore } from '@/stores/useAppPreferencesStore'
import type { ReactNode } from 'react'
import { useLayoutEffect } from 'react'

const THEME_COLOR_BY_THEME = {
  dark: '#171713',
  light: '#006a6a',
} as const

interface AppProviderProps {
  children: ReactNode
}

export function AppProvider({ children }: AppProviderProps) {
  const themePreference = useAppPreferencesStore((state) => state.themePreference)
  const resolvedTheme = useResolvedTheme(themePreference)

  useLayoutEffect(() => {
    const root = document.documentElement
    root.dataset.themePreference = themePreference
    root.dataset.theme = resolvedTheme
    const themeColorMeta = document.querySelector('meta[name="theme-color"]')
    themeColorMeta?.setAttribute('content', THEME_COLOR_BY_THEME[resolvedTheme])
  }, [resolvedTheme, themePreference])

  return <>{children}</>
}
